import React from "react";
import { Checkbox, FormControl, FormControlLabel, TextField } from "@mui/material";
import GroupAllUsers from "../FieldTags/GroupAllUsers";
import xplanLabels from "../../util/XplanLabels";
import HistoryLogElement from "./HistoryLogElement";

const newPlan = window.location.pathname === "/xplans/new";

const TitleSMR = ({ titleSMR, showInSMR, handleChange, xplans }) => {
    return (
        <div id="titleSMR" className="smrField">
            <GroupAllUsers />
            <TextField
                name="titleSMR"
                label={xplanLabels.titleSMR}
                InputLabelProps={{ shrink: true }}
                type="text"
                value={titleSMR ? titleSMR : ""}
                onChange={(e) => handleChange("titleSMR", e.target.value)}
                inputProps={{ maxlength: 54 }}
                className="fullLength"
                variant="standard"
            />
            <FormControl
                id="showInSMR-field"
                name="showInSMR"
            >
                <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                    <FormControlLabel
                        label={xplanLabels.showInSMR}
                        //labelPlacement="start"
                        control={
                            <Checkbox
                                checked={showInSMR === true}
                                onChange={(e) => handleChange("showInSMR", e.target.checked)}
                            />
                        }
                    />
                </div>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"titleSMR"} />}
        </div>
    );
};

export default TitleSMR;